var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M31.718 6.358l-9.705 9.642 9.705 9.642c0.175-0.367 0.282-0.772 0.282-1.205v-16.875c0-0.433-0.106-0.838-0.282-1.205z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M29.188 4.75h-26.375c-0.433 0-0.838 0.106-1.205 0.282l12.404 12.341c1.097 1.097 2.88 1.097 3.977 0l12.404-12.341c-0.367-0.175-0.772-0.282-1.205-0.282z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M0.282 6.358c-0.175 0.367-0.282 0.772-0.282 1.205v16.875c0 0.433 0.106 0.838 0.282 1.205l9.705-9.642-9.705-9.642z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M20.688 17.326l-1.373 1.373c-1.827 1.827-4.801 1.827-6.628 0l-1.373-1.373-9.705 9.642c0.367 0.175 0.772 0.282 1.205 0.282h26.375c0.433 0 0.838-0.106 1.205-0.282l-9.705-9.642z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a55c13f6.svg";
export { ForwardRef as ReactComponent };